"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupplyType = void 0;
var SupplyType;
(function (SupplyType) {
    SupplyType["PURCHASE_ORDER"] = "purchase-order";
    SupplyType["JOB"] = "job";
})(SupplyType = exports.SupplyType || (exports.SupplyType = {}));
//# sourceMappingURL=supply-type.enum.js.map